import Arguments from './Arguments';
import Command from './Command';

const CommandAndArguments: React.FC = () => (
  <>
    <Command />
    <Arguments />
  </>
);

export default CommandAndArguments;
